"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = usePrevious;

var _react = require("react");

// Hook
function usePrevious(value) {
  // The ref object is a generic container whose current property is mutable ...
  // ... and can hold any value, similar to an instance property on a class
  var ref = (0, _react.useRef)(); // Store current value in ref

  (0, _react.useEffect)(function () {
    ref.current = value;
  }, [value]); // Only re-run if value changes
  // Return previous value (happens before update in useEffect above)

  return ref.current;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy91c2VQcmV2aW91cy50cyJdLCJuYW1lcyI6WyJ1c2VQcmV2aW91cyIsInZhbHVlIiwicmVmIiwiY3VycmVudCJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBOztBQUVBO0FBQ2UsU0FBU0EsV0FBVCxDQUF3QkMsS0FBeEIsRUFBa0M7QUFDL0M7QUFDQTtBQUNBLE1BQU1DLEdBQUcsR0FBRyxvQkFBWixDQUgrQyxDQUsvQzs7QUFDQSx3QkFBVSxZQUFNO0FBQ2RBLElBQUFBLEdBQUcsQ0FBQ0MsT0FBSixHQUFjRixLQUFkO0FBQ0QsR0FGRCxFQUVHLENBQUNBLEtBQUQsQ0FGSCxFQU4rQyxDQVFsQztBQUViOztBQUNBLFNBQU9DLEdBQUcsQ0FBQ0MsT0FBWDtBQUNEIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgdXNlRWZmZWN0LCB1c2VSZWYgfSBmcm9tICdyZWFjdCc7XG5cbi8vIEhvb2tcbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIHVzZVByZXZpb3VzPFQ+KHZhbHVlOiBUKSB7XG4gIC8vIFRoZSByZWYgb2JqZWN0IGlzIGEgZ2VuZXJpYyBjb250YWluZXIgd2hvc2UgY3VycmVudCBwcm9wZXJ0eSBpcyBtdXRhYmxlIC4uLlxuICAvLyAuLi4gYW5kIGNhbiBob2xkIGFueSB2YWx1ZSwgc2ltaWxhciB0byBhbiBpbnN0YW5jZSBwcm9wZXJ0eSBvbiBhIGNsYXNzXG4gIGNvbnN0IHJlZiA9IHVzZVJlZjxUPigpO1xuXG4gIC8vIFN0b3JlIGN1cnJlbnQgdmFsdWUgaW4gcmVmXG4gIHVzZUVmZmVjdCgoKSA9PiB7XG4gICAgcmVmLmN1cnJlbnQgPSB2YWx1ZTtcbiAgfSwgW3ZhbHVlXSk7IC8vIE9ubHkgcmUtcnVuIGlmIHZhbHVlIGNoYW5nZXNcblxuICAvLyBSZXR1cm4gcHJldmlvdXMgdmFsdWUgKGhhcHBlbnMgYmVmb3JlIHVwZGF0ZSBpbiB1c2VFZmZlY3QgYWJvdmUpXG4gIHJldHVybiByZWYuY3VycmVudDtcbn1cbiJdfQ==